import React, { useEffect, useState } from "react";
import { bookImageSrc, bookImageFallback } from "./config";
import { useNavigate } from "react-router-dom";
import "../styles/CartPage.css";

const CartPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();

  // Load cart items from localStorage
    useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(storedCart);
    }, []);


  // Remove item from cart
  const removeFromCart = (index) => {
    const updatedCart = cartItems.filter((_, i) => i !== index);
    setCartItems(updatedCart); // ✅ UI turant update karega
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("storage")); // ✅ Navbar ke liye sync
    };

  // Calculate total price
  const getTotalPrice = () => {
    return cartItems.reduce(
      (total, item) => total + (parseFloat(item.price) || 0),
      0
    );
  };

  return (
    <div className="cart-page">
      <h1>Your Cart</h1>

      {cartItems.length === 0 ? (
        <p className="empty-cart">Your cart is empty</p>
      ) : (
        <>
          <div className="cart-list">
            {cartItems.map((item, index) => (
              <div key={index} className="cart-item">
                <img
                  src={bookImageSrc(item, 100, 140)}
                  alt={item.pdf_name}
                  onError={bookImageFallback(item, 100, 140)}
                />
                <div className="cart-details">
                    <div className="cart-header">
                        <h2>{item.pdf_name}</h2>
                        <button
                        className="remove-btn"
                        onClick={() => removeFromCart(index)}
                        >
                        Remove
                        </button>
                    </div>
                    <p className="cart-price">
                        {item.price && item.price !== "0" ? `₹${item.price}` : "Free"}
                    </p>
                    </div>
              </div>
            ))}
          </div>

          {/* Cart Summary */}
          <div className="cart-summary">
            <h2>Total: ₹{getTotalPrice()}</h2>
            <button
              className="checkout-btn"
              onClick={() => alert("Proceeding to checkout...")}
            >
              Checkout
            </button>
            <button className="back-btn" onClick={() => navigate(-1)}>
              Continue Shopping
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;
